import { render, staticRenderFns } from "./SubjectHeader.vue?vue&type=template&id=2593de78&scoped=true"
import script from "./SubjectHeader.ts?vue&type=script&lang=ts&external"
export * from "./SubjectHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./subject-header.scss?vue&type=style&index=0&id=2593de78&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593de78",
  null
  
)

export default component.exports